import {useNuxtApp} from 'nuxt/app'
import {useUserStore} from '@/store/user'
import {useAuthStore} from '@/store/auth'
import type {UserManager} from 'oidc-client-ts'

export function getKeycloakHomePath() {
  const app = useNuxtApp()
  const locale = app.$i18n.locale.value ?? 'en'
  const region = app.$globalization.getRegion(false) ?? 'eu'
  return app.$globalization.localePath('index', locale, region)
}

export function resolveRedirectPath(redirectPath?: string) {
  if (!redirectPath) {
    return '/eu/en'
  }

  const match = /customerUuid=([^&]+)/.exec(redirectPath)
  if (match?.[1]) {
    const userStore = useUserStore()
    userStore.customerUuidLink = match[1]
  }

  return redirectPath
}

export async function clearKeycloakState(userManager?: UserManager | null) {
  const authStore = useAuthStore()
  const userStore = useUserStore()

  authStore.setUserObject(null)
  userStore.accessToken = ''

  if (userManager) {
    await userManager.removeUser()
  }
}
